import { render } from "./Locale.vue?vue&type=template&id=374e1b54&scoped=true"
import script from "./Locale.vue?vue&type=script&lang=js"
export * from "./Locale.vue?vue&type=script&lang=js"

import "./Locale.vue?vue&type=style&index=0&id=374e1b54&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374e1b54"]])

export default __exports__